import {Box, Table, TableBody, TableRow, TableCell, TableHead, Paper, Pagination, Stack, TextField, Grid, Tooltip} from "@mui/material";
import {VerboseLogsPageinationResponse} from "../data/VerboseLogsPageinationResponse";
import {PoliceUser} from "../components/PoliceUser";
import {useSearchParams} from "react-router-dom";
import {formatTimestamp} from "../utils";
import React, {useEffect, useState} from "react";
import {UserActionTypes} from "../data/UserActionTypes";
import QuestionMarkOutlinedIcon from '@mui/icons-material/QuestionMarkOutlined';

export const VerboseLogsPage = () => {
    // eslint-disable-next-line
    const [searchParams, setSearchParams] = useSearchParams()
    const [page, setPage] = useState(searchParams.get("page") ?? "1")
    const [verboseLogs, setVerboseLogs] = useState<VerboseLogsPageinationResponse>({
        totalLogs: 1,
        totalPages: 1,
        logs: []
    });
    const [searchQuery, setSearchQuery] = useState(searchParams.get("query") ?? "")

    const handleChangePage = (event: React.ChangeEvent<unknown>, value: number) => {
        setPage(String(value))
    }

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch(`/api/user/verbose/logs/search?page=${page}&query=${searchQuery}`)
                const data = await response.json()
                setVerboseLogs(data)
            } catch (error) {
                console.error('Error fetching logs:', error)
            }
        };
        fetchData()
    }, [page, searchQuery])

    const totalPages = verboseLogs.totalPages


    return <Stack spacing={1}>
        <Paper variant={"outlined"} style={{
            padding: "16px",
            overflowX: "auto"
        }}>
        <Grid container spacing={2}>
            <Grid sx={{p: 2, display: "flex"}} item xs={12} sm={12} md={12} lg={12}>
                <TextField fullWidth variant="standard" label="Search..." value={searchQuery} onChange={(event) => {
                    setSearchQuery(event.target.value)
                }}/>
                <div style={{flexGrow: 1}}/>
                <Tooltip title="Admin queries can be searched by case insensitive steam names or rp names, while communityids return results for both Admin and Employee queries">
                    <QuestionMarkOutlinedIcon sx={{width: "20px", height: "20px"}}/>
                </Tooltip>
            </Grid>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>Admin</TableCell>
                        <TableCell>Employee</TableCell>
                        <TableCell>Action Type</TableCell>
                        <TableCell>Date</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {verboseLogs.logs && verboseLogs.logs.map((vl) => {
                        return <TableRow>
                        <TableCell><PoliceUser user={{communityId: vl.adminCommunityId, nick: vl.adminNick}}/></TableCell>
                        <TableCell>
                            {vl.userCommunityId !== null ? <PoliceUser user={{communityId: vl.userCommunityId, nick: vl.userNick}}/> : <></>}
                        </TableCell>
                        <TableCell>{UserActionTypes.get(vl.type)?.displayName ?? "Unknown Action Type"}</TableCell>
                        <TableCell>{formatTimestamp(vl.date)}</TableCell>
                        </TableRow>
                    })
                    }
                </TableBody>
            </Table>
            </Grid>
        </Paper>
        <Box sx={{justifyContent: "center", display: "flex", width: "100%", mt: 2}}>
            <Pagination color={'secondary'} count={totalPages} page={Number(page)} onChange={handleChangePage}/>
        </Box>
    </Stack>
}